import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { I18nextProvider } from "react-i18next";
import i18n from "./release/translations/i18n";
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { portalCfg } from './portal.router.config';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe("pk_test_yzzf2JBZ87G0FrfFlhtMFq8700U4Zc6k51");

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Router basename={portalCfg.basename}>
            <Elements stripe={stripePromise}>
                <App />
            </Elements>
        </Router>
    </I18nextProvider>,
    document.getElementById('rootcrm')
);
if (process.env.NODE_ENV !== "development")
    console.log = () => {};


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
